import type { LucideIcon } from 'lucide-react';
import type { ComponentType } from 'react';

import { buttonIconSizePx, type ButtonSize } from './button.kds';

export type IconComponent = LucideIcon | ComponentType<Record<string, unknown>>;

interface IconSlotProps {
  readonly icon: IconComponent;
  readonly size?: ButtonSize;
}

/** @internal Icon glyph sized to KDS button scale. Supports Lucide icons and Chakra createIcon components. */
export const IconSlot = ({ icon: Icon, size = 'rg' }: IconSlotProps) => {
  const px = buttonIconSizePx[size];
  return <Icon aria-hidden data-testid="button-icon" size={px} strokeWidth={2} />;
};
